const routes = {
  index: {
    path: 'index.consult.movement',
    url: '/mouvement',
  },
  home: {
    path: 'index.consult.movement.home',
    url: '/accueil',
  },
  new: {
    path: 'index.consult.movement.new',
    url: '/creer',
  },
  edit: {
    path: 'index.consult.movement.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.movement.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/movement/routes.js